import * as React from 'react';
import Button from '../../../components/Button';
import palette from '../../../components/styles/palette';

export const PrimaryButton = ({
  disabled,
  title,
  handleClick,
  type = 'button',
}) => (
  <Button
    type={type}
    variant="contained"
    disableElevation
    disabled={disabled}
    bgColor={palette.pictonBlue}
    border={palette.btn.blueBorder}
    bgColorDisabled={palette.btn.blueFill}
    data-testid={title}
    onClick={handleClick}
    opacityDisabled={0.38}
  >
    {title}
  </Button>
);
